import { Tooltip } from '@heroui/tooltip';
import { PlanComparer } from '@lib/sanity/sanity.types';
import { SanityI18nProjection } from '@lib/sanity/types/common';
import IconType from '@ui/Icon/StaticIcon/IconType';
import { StaticIcon } from '@ui/Icon/StaticIcon/StaticIcon';
import PortableText, { TextVariant } from '@ui/Text/PortableText';

type Props = {
  plan: SanityI18nProjection<PlanComparer>;
};

export default function FeatureVariant({ plan }: Props) {
  if (plan.variant === 'text') {
    return (
      <div className="flex items-center justify-center">
        <PortableText
          content={plan.featureText}
          variant={TextVariant.TextBodySM}
          className="text-center font-normal leading-5"
        />
        {plan.additionalTooltipDescription && (
          <Tooltip
            className="max-w-xs rounded-lg px-3 py-2"
            color="foreground"
            showArrow
            content={
              <PortableText
                content={plan.additionalTooltipDescription}
                variant={TextVariant.TextBodySM}
                className="text-white"
              />
            }
            closeDelay={0}
          >
            <span className="ml-1 cursor-help">
              <StaticIcon icon={IconType.information} className="size-4 text-gray-400" />
            </span>
          </Tooltip>
        )}
      </div>
    );
  }

  if (plan.variant === 'checkmark') {
    return <StaticIcon icon={IconType.checkmark} className="size-5" />;
  }

  if (plan.variant === 'empty') {
    return '—';
  }

  return null;
}
